"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const custom_cell_1 = require("pages/user-access/user-role/sub-components/custom-cell");
const react_redux_1 = require("react-redux");
const header_menu_1 = __importDefault(require("components/molecules/header-menu"));
const grid_1 = __importDefault(require("components/templates/grid"));
const store_1 = require("store");
const user_role_types_1 = require("../user-role.types");
const user_role_action_1 = __importDefault(require("../user-role.action"));
const user_role_style_1 = __importDefault(require("../user-role.style"));
const user_role_mutation_component_1 = __importDefault(require("./user-role.mutation.component"));
const role_mapping_mutation_component_1 = __importDefault(require("./role-mapping.mutation.component"));
const modal_1 = require("components/molecules/modal");
const svg_1 = require("components/atoms/svg");
const authorization_1 = require("utils/authorization");
const react_router_dom_1 = require("react-router-dom");
const UserRole = () => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const [fullScreen, setFullScreen] = (0, react_1.useState)(true);
    const { dataGrid, dataStates, isLoading, isSuccess, isError, errorMessage } = (0, store_1.useAppSelector)((state) => state.userAccess.userRoleReducer);
    const { appTheme } = (0, store_1.useAppSelector)((state) => state.app);
    const { userData } = (0, store_1.useAppSelector)((state) => state.auth);
    const isAuthorized = (0, authorization_1.userRoleAuth)(userData.authorization, 'User Access', 'User Role');
    (0, react_1.useEffect)(() => {
        if (isAuthorized.view) {
            if (isLoading)
                dispatch(user_role_action_1.default.getDataGrid(dataStates));
        }
        else {
            navigate('/dashboard', { replace: true });
        }
    }, [isLoading, isAuthorized, fullScreen]);
    const actionCellRender = (0, custom_cell_1.actionCell)([
        {
            type: 'other',
            icon: (0, jsx_runtime_1.jsx)(svg_1.EditIcon, { color: appTheme === 'dark' ? '#fff' : '#424242' }),
            onClick: (d) => dispatch(user_role_action_1.default.onClickMutation({
                mutationMode: 'edit',
                dataItem: Object.assign(Object.assign({}, d), { modified_by: userData.id }),
                isSuccess: false,
            })),
            permission: isAuthorized.change,
        },
        {
            type: 'other',
            icon: (0, jsx_runtime_1.jsx)(svg_1.DeleteIcon, { color: appTheme === 'dark' ? '#fff' : '#424242' }),
            onClick: (d) => dispatch(user_role_action_1.default.onClickMutation({ mutationMode: 'delete', dataItem: d, isSuccess: false })),
            permission: isAuthorized.change,
        },
        {
            type: 'other',
            icon: (0, jsx_runtime_1.jsx)(svg_1.RoleMappingIcon, { color: appTheme === 'dark' ? '#fff' : '#424242' }),
            onClick: (d) => dispatch(user_role_action_1.default.onClickMutation({
                mutationMode: 'mappingModule',
                dataItem: Object.assign(Object.assign({}, d), { modified_by: userData.id }),
                isSuccess: false,
            })),
            permission: isAuthorized.change,
        },
    ]);
    const actionColumn = [
        {
            title: '',
            width: '100px',
            sortable: false,
            filterable: false,
            show: isAuthorized.change,
            cell: actionCellRender,
            locked: true
        },
    ];
    const onDataStateChange = (types, val) => {
        const newDataStates = Object.assign(Object.assign({}, dataStates), { skip: types === 'page' ? (val - 1) * dataStates.take : 0, take: types === 'take' ? val : dataStates.take });
        dispatch(user_role_action_1.default.onDataStateChange(newDataStates));
    };
    const onFilterChange = (e) => {
        dispatch(user_role_action_1.default.onFilterChange(e.filter));
        const newDataStates = Object.assign(Object.assign({}, dataStates), { filter: e.filter });
        dispatch(user_role_action_1.default.getDataGrid(newDataStates));
    };
    const onSortChange = (e) => {
        dispatch(user_role_action_1.default.onDataStateChange(Object.assign(Object.assign({}, dataStates), { sort: e.sort })));
    };
    //checkfullscreen
    const widthCheker = () => {
        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        setFullScreen(width >= window.screen.width);
    };
    (0, react_1.useEffect)(() => {
        widthCheker();
    }, []);
    window.onload = widthCheker;
    window.onresize = widthCheker;
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(header_menu_1.default, { theme: appTheme, isLoading: isLoading, title: 'User Role & Mapping', isAddNew: isAuthorized.change, onAddNew: () => dispatch(user_role_action_1.default.onClickMutation({ mutationMode: 'add', isSuccess: false })) }), (0, jsx_runtime_1.jsx)(modal_1.ModalSuccess, { show: isSuccess, appTheme: appTheme, messageSuccess: 'Data saved Successfully', onClose: () => {
                    dispatch(user_role_action_1.default.onDataStateChange(dataStates));
                    dispatch(user_role_action_1.default.onClickMutation({ mutationMode: false, isSuccess: false }));
                } }), (0, jsx_runtime_1.jsx)(modal_1.ModalError, { appTheme: appTheme, show: isError, errorMessage: errorMessage, onClose: () => dispatch(user_role_action_1.default.closeError()), style: { zIndex: 10 } }), (0, jsx_runtime_1.jsx)(user_role_mutation_component_1.default, {}), (0, jsx_runtime_1.jsx)(role_mapping_mutation_component_1.default, {}), (0, jsx_runtime_1.jsx)(grid_1.default, { style: user_role_style_1.default.gridHeight, dataGrid: dataGrid, columns: actionColumn.concat(!fullScreen ? user_role_types_1.userRoleColumnProps : user_role_types_1.userRoleColumnPropsFullSize), dataStates: dataStates, fullScreen: fullScreen, pageable: true, sortable: true, sort: dataStates.sort, onPageChange: (v) => onDataStateChange('page', v), onTakeChange: (v) => onDataStateChange('take', v), onSortChange: onSortChange, onFilterChange: onFilterChange })] }));
};
exports.default = UserRole;
